export function getWindevLang (lang:string) {
    switch (lang) {
        case 'nl':
            return 12
            break;
        case 'en':
            return 3
        case 'fr':
            return 5
        default:
            return 12
            break;
    }
}